import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { isMobile } from 'react-device-detect';

import styles from './emailCaptureCloud.css';
import EmailCaptureForm from '../EmailCaptureForm';
import CloseIcon from '../../../assets/svg/CloseIcon';
import EmailCloud from '../../../assets/svg/EmailCloud';

const EmailCaptureCloud = ({ onClose, maxYBound }) => {
  const requestRef = useRef();
  const hogRef = useRef();

  const [isAnimating, setIsAnimating] = useState(true);
  const [hogX, setHogX] = useState(0);
  const [hogY, setHogY] = useState(0);
  const [hogRect, setHogRect] = useState([0, 0]);
  const hog = {
    x: 100,
    y: 100,
    vx: 5,
    vy: 2,
  };

  const animateHog = () => {
    hog.x += hog.vx;
    hog.y += hog.vy;

    // Change directions if hog hits y-bounds
    if (hog.y + hog.vy >= maxYBound - hogRect[1] || hog.y + hog.vy < 0) {
      hog.vy = -hog.vy;
    }

    // Change directions if hog hits x-bounds
    if (hog.x + hog.vx > window.innerWidth - hogRect[0] || hog.x + hog.vx < 0) {
      hog.vx = -hog.vx;
    }

    setHogX(hog.x);
    setHogY(hog.y);
    requestRef.current = requestAnimationFrame(animateHog);
  };

  const handleMouseDown = () => {
    cancelAnimationFrame(requestRef.current);
    setIsAnimating(false);
  };

  useEffect(() => {
    // Disable bouncing animation on mobile
    if (isMobile) {
      setIsAnimating(false);
      return;
    }

    if (hogRect[0] > 0 && hogRect[1] > 0) {
      requestRef.current = requestAnimationFrame(animateHog);
    }
    return () => cancelAnimationFrame(requestRef.current);
  }, [hogRect]);

  useEffect(() => {
    if (hogRef.current) {
      const { width, height } = hogRef.current.getBoundingClientRect();
      setHogRect([width, height]);
    }
  }, [hogRef]);

  return (
    <Draggable
      // TODO: set random starting position for mobile
      defaultPosition={{ x: 50, y: 150 }}
      position={isAnimating && !isMobile ? { x: hogX, y: hogY } : null}
      bounds={{
        left: 0,
        top: 0,
        right: window.innerWidth - hogRect[0],
        bottom: maxYBound - hogRect[1],
      }}
      onMouseDown={handleMouseDown}
      cancel=".not-draggable">
      <div className={styles.wrapper}>
        <div ref={hogRef} className={styles.cloudWrapper}>
          <EmailCloud />
        </div>
        <EmailCaptureForm subscribeButtonClass={styles.subscribeButton} />
        {!isAnimating && (
          <button onClick={onClose} className={`not-draggable ${styles.closeBtn}`}>
            <CloseIcon />
          </button>
        )}
      </div>
    </Draggable>
  );
};

EmailCaptureCloud.propTypes = {
  onClose: PropTypes.func,
  maxYBound: PropTypes.number,
};

export default EmailCaptureCloud;
